import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { cn } from '../../lib/utils';

interface HelpIconProps {
  text: string;
  className?: string;
  position?: 'top' | 'bottom' | 'left' | 'right' | 'top-left' | 'bottom-left';
}

export const HelpIcon: React.FC<HelpIconProps> = ({ text, className, position = 'top' }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative inline-flex items-center group cursor-pointer">
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        className={cn(
          "p-0.5 text-slate-400 hover:text-blue-600 transition-colors focus:outline-none rounded-full",
          className
        )}
        aria-label="Ayuda contextual"
      >
        <HelpCircle size={14} />
      </button>

      {isOpen && (
        <div
          className={cn(
            "absolute z-50 bg-slate-900/95 backdrop-blur-xs text-white text-[11px] font-normal px-3 py-2 rounded-xl shadow-xl border border-slate-700/80 w-60 leading-relaxed pointer-events-none animate-in fade-in zoom-in-95 duration-150",
            position === 'top' && "-top-2 left-1/2 -translate-x-1/2 -translate-y-full mb-1",
            position === 'bottom' && "-bottom-2 left-1/2 -translate-x-1/2 translate-y-full mt-1",
            position === 'left' && "top-1/2 -left-2 -translate-y-1/2 -translate-x-full mr-1",
            position === 'right' && "top-1/2 -right-2 -translate-y-1/2 translate-x-full ml-1",
            position === 'top-left' && "-top-2 right-0 -translate-y-full mb-1",
            position === 'bottom-left' && "-bottom-2 right-0 translate-y-full mt-1"
          )}
        >
          {text}
        </div>
      )}
    </div>
  );
};
